import { render } from "./compliance_procurement.html?vue&type=template&id=76171bee&external"
import script from "./compliance_procurement.js?vue&type=script&lang=js&external"
export * from "./compliance_procurement.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__